import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  clock: {

  },
}))

export default useStyles
